<template>
<div id = "home" style="height:100%;overflow-y:hidden;">
  <div id="header" style="height:5%;">
    <WifiMonitor style="height:5%;" title="Wi-Mon" message="東京大学 wifi 混雑度モニタ" :fav_filter="true" :if_sp="ifsp"/>
  </div>
  <div style="height:100%;margin-top:0;overflow-y:hidden;width:100%">
    <div id="main_sp" style="height:90%;overflow-y:hidden;" v-if="ifsp">
      <Map :fav_filter="true" :if_sp="ifsp"></Map>
    </div>

    <div id="main_pc" style="width:100%;height:88%;overflow-y:hidden;" v-if="!ifsp">
      <Map style="width:100%;" :fav_filter="true" :if_sp="ifsp"></Map>
    </div>
  </div>
</div>
</template>

<script>
import WifiMonitor from '../components/WifiMonitor.vue'
import Map from '../components/Maps.vue'
export default {
  name: 'Home',
  props:{
    ifsp:{
      type: Boolean,
      default: true
    }
  },
  components: {
    WifiMonitor,
    Map,
  },
  mounted(){
    document.title = "お気に入りマップ一覧"
  }
}
</script>

<style>
@import "./root_component.css";
</style>

